<template>
    <img src="/images/promo/hero-section/card-index.png"
     alt="Card index" />
</template>

<script>
export default {};
</script>
